export const countryCodes = [
  {
    country_code: "AF",
    text: "Afghanistan",
    value: "+93"
  },
  {
    country_code: "AL",
    text: "Albania",
    value: "+355"
  },
  {
    country_code: "DZ",
    text: "Algeria",
    value: "+213"
  },
  {
    country_code: "AS",
    text: "American Samoa",
    value: "+1"
  },
  {
    country_code: "AD",
    text: "Andorra",
    value: "+376"
  },
  {
    country_code: "AO",
    text: "Angola",
    value: "+244"
  },
  {
    country_code: "AI",
    text: "Anguilla",
    value: "+1"
  },
  {
    country_code: "AG",
    text: "Antigua",
    value: "+1"
  },
  {
    country_code: "AR",
    text: "Argentina",
    value: "+54"
  },
  {
    country_code: "AM",
    text: "Armenia",
    value: "+374"
  },
  {
    country_code: "AW",
    text: "Aruba",
    value: "+297"
  },
  {
    country_code: "AU",
    text: "Australia",
    value: "+61"
  },
  {
    country_code: "AI",
    text: "Austria",
    value: "+43"
  },
  {
    country_code: "AZ",
    text: "Azerbaijan",
    value: "+994"
  },
  {
    country_code: "BH",
    text: "Bahrain",
    value: "+973"
  },
  {
    country_code: "BD",
    text: "Bangladesh",
    value: "+880"
  },
  {
    country_code: "BB",
    text: "Barbados",
    value: "+1"
  },
  {
    country_code: "BY",
    text: "Belarus",
    value: "+375"
  },
  {
    country_code: "BE",
    text: "Belgium",
    value: "+32"
  },
  {
    country_code: "BZ",
    text: "Belize",
    value: "+501"
  },
  {
    country_code: "BJ",
    text: "Benin",
    value: "+229"
  },
  {
    country_code: "BM",
    text: "Bermuda",
    value: "+1"
  },
  {
    country_code: "BT",
    text: "Bhutan",
    value: "+975"
  },
  {
    country_code: "BO",
    text: "Bolivia",
    value: "+591"
  },
  {
    country_code: "BA",
    text: "Bosnia and Herzegovina",
    value: "+387"
  },
  {
    country_code: "BW",
    text: "Botswana",
    value: "+267"
  },
  {
    country_code: "BR",
    text: "Brazil",
    value: "+55"
  },
  {
    country_code: "IO",
    text: "British Indian Ocean Territory",
    value: "+246"
  },
  {
    country_code: "VG",
    text: "British Virgin Islands",
    value: "+1"
  },
  {
    country_code: "BN",
    text: "Brunei",
    value: "+673"
  },
  {
    country_code: "BG",
    text: "Bulgaria",
    value: "+359"
  },
  {
    country_code: "BF",
    text: "Burkina Faso",
    value: "+226"
  },
  {
    country_code: "MM",
    text: "Burma Myanmar",
    value: "+95"
  },
  {
    country_code: "BI",
    text: "Burundi",
    value: "+257"
  },
  {
    country_code: "KH",
    text: "Cambodia",
    value: "+855"
  },
  {
    country_code: "CM",
    text: "Cameroon",
    value: "+237"
  },
  {
    country_code: "CA",
    text: "Canada",
    value: "+1"
  },
  {
    country_code: "CV",
    text: "Cape Verde",
    value: "+238"
  },
  {
    country_code: "KY",
    text: "Cayman Islands",
    value: "+1"
  },
  {
    country_code: "CF",
    text: "Central African Republic",
    value: "+236"
  },
  {
    country_code: "ID",
    text: "Chad",
    value: "+235"
  },
  {
    country_code: "CL",
    text: "Chile",
    value: "+56"
  },
  {
    country_code: "CN",
    text: "China",
    value: "+86"
  },
  {
    country_code: "CO",
    text: "Colombia",
    value: "+57"
  },
  {
    country_code: "KM",
    text: "Comoros",
    value: "+269"
  },
  {
    country_code: "CK",
    text: "Cook Islands",
    value: "+682"
  },
  {
    country_code: "CR",
    text: "Costa Rica",
    value: "+506"
  },
  {
    country_code: "CI",
    text: "Côte d'Ivoire",
    value: "+225"
  },
  {
    country_code: "HR",
    text: "Croatia",
    value: "+385"
  },
  {
    country_code: "CU",
    text: "Cuba",
    value: "+53"
  },
  {
    country_code: "CY",
    text: "Cyprus",
    value: "+357"
  },
  {
    country_code: "CZ",
    text: "Czech Republic",
    value: "+420"
  },
  {
    country_code: "CD",
    text: "Democratic Republic of Congo",
    value: "+243"
  },
  {
    country_code: "DK",
    text: "Denmark",
    value: "+45"
  },
  {
    country_code: "DJ",
    text: "Djibouti",
    value: "+253"
  },
  {
    country_code: "DM",
    text: "Dominica",
    value: "+1"
  },
  {
    country_code: "DO",
    text: "Dominican Republic",
    value: "+1"
  },
  {
    country_code: "EC",
    text: "Ecuador",
    value: "+593"
  },
  {
    country_code: "EG",
    text: "Egypt",
    value: "+20"
  },
  {
    country_code: "SV",
    text: "El Salvador",
    value: "+503"
  },
  {
    country_code: "GQ",
    text: "Equatorial Guinea",
    value: "+240"
  },
  {
    country_code: "ER",
    text: "Eritrea",
    value: "+291"
  },
  {
    country_code: "EE",
    text: "Estonia",
    value: "+372"
  },
  {
    country_code: "ET",
    text: "Ethiopia",
    value: "+251"
  },
  {
    country_code: "FK",
    text: "Falkland Islands",
    value: "+500"
  },
  {
    country_code: "FO",
    text: "Faroe Islands",
    value: "+298"
  },
  {
    country_code: "FM",
    text: "Federated States of Micronesia",
    value: "+691"
  },
  {
    country_code: "FJ",
    text: "Fiji",
    value: "+679"
  },
  {
    country_code: "FI",
    text: "Finland",
    value: "+358"
  },
  {
    country_code: "FR",
    text: "France",
    value: "+33"
  },
  {
    country_code: "GF",
    text: "French Guiana",
    value: "+594"
  },
  {
    country_code: "PF",
    text: "French Polynesia",
    value: "+689"
  },
  {
    country_code: "GA",
    text: "Gabon",
    value: "+241"
  },
  {
    country_code: "GE",
    text: "Georgia",
    value: "+995"
  },
  {
    country_code: "DE",
    text: "Germany",
    value: "+49"
  },
  {
    country_code: "GH",
    text: "Ghana",
    value: "+233"
  },
  {
    country_code: "GI",
    text: "Gibraltar",
    value: "+350"
  },
  {
    country_code: "GR",
    text: "Greece",
    value: "+30"
  },
  {
    country_code: "GL",
    text: "Greenland",
    value: "+299"
  },
  {
    country_code: "GD",
    text: "Grenada",
    value: "+1"
  },
  {
    country_code: "GP",
    text: "Guadeloupe",
    value: "+590"
  },
  {
    country_code: "GU",
    text: "Guam",
    value: "+1"
  },
  {
    country_code: "GT",
    text: "Guatemala",
    value: "+502"
  },
  {
    country_code: "GN",
    text: "Guinea",
    value: "+224"
  },
  {
    country_code: "GW",
    text: "Guinea-Bissau",
    value: "+245"
  },
  {
    country_code: "GY",
    text: "Guyana",
    value: "+592"
  },
  {
    country_code: "HT",
    text: "Haiti",
    value: "+509"
  },
  {
    country_code: "HN",
    text: "Honduras",
    value: "+504"
  },
  {
    country_code: "HK",
    text: "Hong Kong",
    value: "+852"
  },
  {
    country_code: "HU",
    text: "Hungary",
    value: "+36"
  },
  {
    country_code: "IS",
    text: "Iceland",
    value: "+354"
  },
  {
    country_code: "IN",
    text: "India",
    value: "+91"
  },
  {
    country_code: "ID",
    text: "Indonesia",
    value: "+62"
  },
  {
    country_code: "IR",
    text: "Iran",
    value: "+98"
  },
  {
    country_code: "IQ",
    text: "Iraq",
    value: "+964"
  },
  {
    country_code: "IE",
    text: "Ireland",
    value: "+353"
  },
  {
    country_code: "IL",
    text: "Israel",
    value: "+972"
  },
  {
    country_code: "IT",
    text: "Italy",
    value: "+39"
  },
  {
    country_code: "JM",
    text: "Jamaica",
    value: "+1"
  },
  {
    country_code: "JP",
    text: "Japan",
    value: "+81"
  },
  {
    country_code: "JO",
    text: "Jordan",
    value: "+962"
  },
  {
    country_code: "KZ",
    text: "Kazakhstan",
    value: "+7"
  },
  {
    country_code: "KE",
    text: "Kenya",
    value: "+254"
  },
  {
    country_code: "KI",
    text: "Kiribati",
    value: "+686"
  },
  {
    country_code: "XK",
    text: "Kosovo",
    value: "+381"
  },
  {
    country_code: "KW",
    text: "Kuwait",
    value: "+965"
  },
  {
    country_code: "KG",
    text: "Kyrgyzstan",
    value: "+996"
  },
  {
    country_code: "LA",
    text: "Laos",
    value: "+856"
  },
  {
    country_code: "LV",
    text: "Latvia",
    value: "+371"
  },
  {
    country_code: "LB",
    text: "Lebanon",
    value: "+961"
  },
  {
    country_code: "LS",
    text: "Lesotho",
    value: "+266"
  },
  {
    country_code: "LR",
    text: "Liberia",
    value: "+231"
  },
  {
    country_code: "LY",
    text: "Libya",
    value: "+218"
  },
  {
    country_code: "LI",
    text: "Liechtenstein",
    value: "+423"
  },
  {
    country_code: "LT",
    text: "Lithuania",
    value: "+370"
  },
  {
    country_code: "LU",
    text: "Luxembourg",
    value: "+352"
  },
  {
    country_code: "MO",
    text: "Macau",
    value: "+853"
  },
  {
    country_code: "MK",
    text: "Macedonia",
    value: "+389"
  },
  {
    country_code: "MG",
    text: "Madagascar",
    value: "+261"
  },
  {
    country_code: "MW",
    text: "Malawi",
    value: "+265"
  },
  {
    country_code: "MY",
    text: "Malaysia",
    value: "+60"
  },
  {
    country_code: "MV",
    text: "Maldives",
    value: "+960"
  },
  {
    country_code: "ML",
    text: "Mali",
    value: "+223"
  },
  {
    country_code: "MT",
    text: "Malta",
    value: "+356"
  },
  {
    country_code: "MH",
    text: "Marshall Islands",
    value: "+692"
  },
  {
    country_code: "MQ",
    text: "Martinique",
    value: "+596"
  },
  {
    country_code: "MR",
    text: "Mauritania",
    value: "+222"
  },
  {
    country_code: "MU",
    text: "Mauritius",
    value: "+230"
  },
  {
    country_code: "YT",
    text: "Mayotte",
    value: "+262"
  },
  {
    country_code: "MX",
    text: "Mexico",
    value: "+52"
  },
  {
    country_code: "MD",
    text: "Moldova",
    value: "+373"
  },
  {
    country_code: "MC",
    text: "Monaco",
    value: "+377"
  },
  {
    country_code: "MN",
    text: "Mongolia",
    value: "+976"
  },
  {
    country_code: "ME",
    text: "Montenegro",
    value: "+382"
  },
  {
    country_code: "MS",
    text: "Montserrat",
    value: "+1"
  },
  {
    country_code: "MA",
    text: "Morocco",
    value: "+212"
  },
  {
    country_code: "MZ",
    text: "Mozambique",
    value: "+258"
  },
  {
    country_code: "NA",
    text: "Namibia",
    value: "+264"
  },
  {
    country_code: "NR",
    text: "Nauru",
    value: "+674"
  },
  {
    country_code: "NP",
    text: "Nepal",
    value: "+977"
  },
  {
    country_code: "NL",
    text: "Netherlands",
    value: "+31"
  },
  {
    country_code: "AN",
    text: "Netherlands Antilles",
    value: "+599"
  },
  {
    country_code: "NC",
    text: "New Caledonia",
    value: "+687"
  },
  {
    country_code: "NZ",
    text: "New Zealand",
    value: "+64"
  },
  {
    country_code: "NI",
    text: "Nicaragua",
    value: "+505"
  },
  {
    country_code: "NE",
    text: "Niger",
    value: "+227"
  },
  {
    country_code: "NG",
    text: "Nigeria",
    value: "+234"
  },
  {
    country_code: "NU",
    text: "Niue",
    value: "+683"
  },
  {
    country_code: "NF",
    text: "Norfolk Island",
    value: "+672"
  },
  {
    country_code: "KP",
    text: "North Korea",
    value: "+850"
  },
  {
    country_code: "MP",
    text: "Northern Mariana Islands",
    value: "+1"
  },
  {
    country_code: "NO",
    text: "Norway",
    value: "+47"
  },
  {
    country_code: "OM",
    text: "Oman",
    value: "+968"
  },
  {
    country_code: "PK",
    text: "Pakistan",
    value: "+92"
  },
  {
    country_code: "PW",
    text: "Palau",
    value: "+680"
  },
  {
    country_code: "PS",
    text: "Palestine",
    value: "+970"
  },
  {
    country_code: "PA",
    text: "Panama",
    value: "+507"
  },
  {
    country_code: "PG",
    text: "Papua New Guinea",
    value: "+675"
  },
  {
    country_code: "PY",
    text: "Paraguay",
    value: "+595"
  },
  {
    country_code: "PE",
    text: "Peru",
    value: "+51"
  },
  {
    country_code: "PH",
    text: "Philippines",
    value: "+63"
  },
  {
    country_code: "PL",
    text: "Poland",
    value: "+48"
  },
  {
    country_code: "PT",
    text: "Portugal",
    value: "+351"
  },
  {
    country_code: "PR",
    text: "Puerto Rico",
    value: "+1"
  },
  {
    country_code: "QA",
    text: "Qatar",
    value: "+974"
  },
  {
    country_code: "CG",
    text: "Republic of the Congo",
    value: "+242"
  },
  {
    country_code: "RE",
    text: "Réunion",
    value: "+262"
  },
  {
    country_code: "RO",
    text: "Romania",
    value: "+40"
  },
  {
    country_code: "RU",
    text: "Russia",
    value: "+7"
  },
  {
    country_code: "RW",
    text: "Rwanda",
    value: "+250"
  },
  {
    country_code: "BL",
    text: "Saint Barthélemy",
    value: "+590"
  },
  {
    country_code: "SH",
    text: "Saint Helena",
    value: "+290"
  },
  {
    country_code: "KN",
    text: "Saint Kitts and Nevis",
    value: "+1"
  },
  {
    country_code: "MF",
    text: "Saint Martin",
    value: "+590"
  },
  {
    country_code: "PM",
    text: "Saint Pierre and Miquelon",
    value: "+508"
  },
  {
    country_code: "VC",
    text: "Saint Vincent and the Grenadines",
    value: "+1"
  },
  {
    country_code: "WS",
    text: "Samoa",
    value: "+685"
  },
  {
    country_code: "SM",
    text: "San Marino",
    value: "+378"
  },
  {
    country_code: "ST",
    text: "São Tomé and Príncipe",
    value: "+239"
  },
  {
    country_code: "SA",
    text: "Saudi Arabia",
    value: "+966"
  },
  {
    country_code: "SN",
    text: "Senegal",
    value: "+221"
  },
  {
    country_code: "RS",
    text: "Serbia",
    value: "+381"
  },
  {
    country_code: "SC",
    text: "Seychelles",
    value: "+248"
  },
  {
    country_code: "SL",
    text: "Sierra Leone",
    value: "+232"
  },
  {
    country_code: "SG",
    text: "Singapore",
    value: "+65"
  },
  {
    country_code: "SK",
    text: "Slovakia",
    value: "+421"
  },
  {
    country_code: "SI",
    text: "Slovenia",
    value: "+386"
  },
  {
    country_code: "SB",
    text: "Solomon Islands",
    value: "+677"
  },
  {
    country_code: "SO",
    text: "Somalia",
    value: "+252"
  },
  {
    country_code: "ZA",
    text: "South Africa",
    value: "+27"
  },
  {
    country_code: "KR",
    text: "South Korea",
    value: "+82"
  },
  {
    country_code: "ES",
    text: "Spain",
    value: "+34"
  },
  {
    country_code: "LK",
    text: "Sri Lanka",
    value: "+94"
  },
  {
    country_code: "LC",
    text: "St. Lucia",
    value: "+1"
  },
  {
    country_code: "SD",
    text: "Sudan",
    value: "+249"
  },
  {
    country_code: "SR",
    text: "Suriname",
    value: "+597"
  },
  {
    country_code: "SZ",
    text: "Swaziland",
    value: "+268"
  },
  {
    country_code: "SE",
    text: "Sweden",
    value: "+46"
  },
  {
    country_code: "CH",
    text: "Switzerland",
    value: "+41"
  },
  {
    country_code: "SY",
    text: "Syria",
    value: "+963"
  },
  {
    country_code: "TW",
    text: "Taiwan",
    value: "+886"
  },
  {
    country_code: "TJ",
    text: "Tajikistan",
    value: "+992"
  },
  {
    country_code: "TZ",
    text: "Tanzania",
    value: "+255"
  },
  {
    country_code: "TH",
    text: "Thailand",
    value: "+66"
  },
  {
    country_code: "BS",
    text: "The Bahamas",
    value: "+1"
  },
  {
    country_code: "GM",
    text: "The Gambia",
    value: "+220"
  },
  {
    country_code: "TL",
    text: "Timor-Leste",
    value: "+670"
  },
  {
    country_code: "TG",
    text: "Togo",
    value: "+228"
  },
  {
    country_code: "TK",
    text: "Tokelau",
    value: "+690"
  },
  {
    country_code: "TO",
    text: "Tonga",
    value: "+676"
  },
  {
    country_code: "TT",
    text: "Trinidad and Tobago",
    value: "+1"
  },
  {
    country_code: "TN",
    text: "Tunisia",
    value: "+216"
  },
  {
    country_code: "TR",
    text: "Turkey",
    value: "+90"
  },
  {
    country_code: "TM",
    text: "Turkmenistan",
    value: "+993"
  },
  {
    country_code: "TC",
    text: "Turks and Caicos Islands",
    value: "+1"
  },
  {
    country_code: "TV",
    text: "Tuvalu",
    value: "+688"
  },
  {
    country_code: "UG",
    text: "Uganda",
    value: "+256"
  },
  {
    country_code: "UA",
    text: "Ukraine",
    value: "+380"
  },
  {
    country_code: "AE",
    text: "United Arab Emirates",
    value: "+971"
  },
  {
    country_code: "GB",
    text: "United Kingdom",
    value: "+44"
  },
  {
    country_code: "US",
    text: "United States",
    value: "+1"
  },
  {
    country_code: "UY",
    text: "Uruguay",
    value: "+598"
  },
  {
    country_code: "VI",
    text: "US Virgin Islands",
    value: "+1"
  },
  {
    country_code: "UZ",
    text: "Uzbekistan",
    value: "+998"
  },
  {
    country_code: "VU",
    text: "Vanuatu",
    value: "+678"
  },
  {
    country_code: "VA",
    text: "Vatican City",
    value: "+39"
  },
  {
    country_code: "VE",
    text: "Venezuela",
    value: "+58"
  },
  {
    country_code: "VN",
    text: "Vietnam",
    value: "+84"
  },
  {
    country_code: "WF",
    text: "Wallis and Futuna",
    value: "+681"
  },
  {
    country_code: "YE",
    text: "Yemen",
    value: "+967"
  },
  {
    country_code: "ZM",
    text: "Zambia",
    value: "+260"
  },
  {
    country_code: "ZW",
    text: "Zimbabwe",
    value: "+263"
  }
];
